/**
 * Given a container and an element inside it, make sure the inner element is
 * visible by scrolling the container. Based on code from
 * http://stackoverflow.com/questions/6215779.
 */
export default function ensureElementIsVisible(parent, element) {
  const top = element.getBoundingClientRect().top - parent.getBoundingClientRect().top
  const height = element.offsetHeight

  const visibleAreaStart = parent.scrollTop
  const parentHeight = parent.offsetHeight

  if (top < 0) {
    parent.scrollTo({ top: visibleAreaStart + top })
  } else {
    parent.scrollTo({ top: visibleAreaStart + top + height - parentHeight })
  }
}
